import Vue from 'vue'
import CryptoJS from 'crypto-js'
import {
  Toast
} from 'vant'

const key = CryptoJS.enc.Utf8.parse("625222f9149e961d"); //十六位十六进制数作为密钥
const iv = CryptoJS.enc.Utf8.parse('5efdtf6060e2o330'); //十六位十六进制数作为密钥偏移量

//解密方法
function Decrypt(word) {
  let encryptedHexStr = CryptoJS.enc.Hex.parse(word);
  let srcs = CryptoJS.enc.Base64.stringify(encryptedHexStr);
  let decrypt = CryptoJS.AES.decrypt(srcs, key, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7
  });
  let decryptedStr = decrypt.toString(CryptoJS.enc.Utf8);
  return decryptedStr.toString();
}

//加密方法
function Encrypt(word) {
  let srcs = CryptoJS.enc.Utf8.parse(word);
  let encrypted = CryptoJS.AES.encrypt(srcs, key, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7
  });
  return encrypted.ciphertext.toString().toUpperCase();
}


export function loding() {
  const toast = Toast.loading({
    duration: 1000, // 持续展示 toast
    forbidClick: true, // 禁用背景点击
    // mask: true,//开启遮罩层
    loadingType: "spinner",
    message: "加载中..."
  });
}


export default {
  Decrypt,
  Encrypt,
}



// WEBPACK FOOTER //
// ./src/assets/js/utils.js